unit View.Apagar.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewApagarEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbaliado_id: TLabel;
    edaliado_id: TDBEdit;
    lbdata_base_id: TLabel;
    eddata_base_id: TDBEdit;
    lbmodalidade_id: TLabel;
    edmodalidade_id: TDBEdit;
    lbcompra_id: TLabel;
    edcompra_id: TDBEdit;
    lbfornecedor_id: TLabel;
    edfornecedor_id: TDBEdit;
    lbplano_contas_id: TLabel;
    edplano_contas_id: TDBEdit;
    lbdocumento: TLabel;
    eddocumento: TDBEdit;
    lbparcela: TLabel;
    edparcela: TDBEdit;
    lbvalor: TLabel;
    edvalor: TDBEdit;
    lbsaldo: TLabel;
    edsaldo: TDBEdit;
    lbpago: TLabel;
    edpago: TDBEdit;
    lbemissao: TLabel;
    edemissao: TDBEdit;
    lbvencimento: TLabel;
    edvencimento: TDBEdit;
    lbpagamento: TLabel;
    edpagamento: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientApagarGet: TXDataWebClient;
    XDataClientApagarDelete: TXDataWebClient;
    ApagarDataset: TXDataWebDataSet;
    ApagarDatasetid: TIntegerField;
    ApagarDatasetaliado_id: TIntegerField;
    ApagarDatasetdata_base_id: TIntegerField;
    ApagarDatasetmodalidade_id: TIntegerField;
    ApagarDatasetcompra_id: TIntegerField;
    ApagarDatasetfornecedor_id: TIntegerField;
    ApagarDatasetplano_contas_id: TIntegerField;
    ApagarDatasetdocumento: TStringField;
    ApagarDatasetparcela: TStringField;
    ApagarDatasetvalor: TFloatField;
    ApagarDatasetsaldo: TFloatField;
    ApagarDatasetpago: TFloatField;
    ApagarDatasetemissao: TDateTimeField;
    ApagarDatasetvencimento: TDateTimeField;
    ApagarDatasetpagamento: TDateTimeField;
    ApagarDatasetcodigo_interno: TIntegerField;
    ApagarDatasetexcluido: TBooleanField;
    ApagarDatasetinclusao: TDateTimeField;
    ApagarDatasetalteracao: TDateTimeField;
    ApagarDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientApagarGetLoad(Response: TXDataClientResponse);
    procedure XDataClientApagarDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientApagarDeleteError(Error: TXDataClientError);
    procedure ApagarDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewApagarEdit: TFViewApagarEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewApagarEdit }

procedure TFViewApagarEdit.btSaveClick(Sender: TObject);
begin
  if ApagarDataset.State in dsEditModes then
  begin
        ApagarDataset.Post;
    ApagarDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewApagarEdit.btDeleteClick(Sender: TObject);
begin
  if ApagarDataset.State in dsEditModes then
    ApagarDataset.Post;
  XDataClientApagarDelete.Delete(ApagarDataset.EntitySetName,
    TJSObject(ApagarDataset.CurrentData));
end;


class function TFViewApagarEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewApagarEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewApagarEdit.InsertEntity;
begin
  ApagarDataset.Close;
  ApagarDataset.SetJsonData('{}');
  ApagarDataset.Open;
  ApagarDataset.Insert;
end;

class function TFViewApagarEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewApagarEdit(AForm).FInserting := AInserting;
    TFViewApagarEdit(AForm).FId := AId;
    TFViewApagarEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewApagarEdit(AForm).InsertEntity
    else
      TFViewApagarEdit(AForm).LoadEntity;
    TFViewApagarEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewApagarEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewApagarEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    ApagarDataset.Connection.Model.DefaultSchema.FindEntityType(
      ApagarDataset.EntitySetName
    )
  );
  XDataClientApagarGet.Get(ApagarDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewApagarEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewApagarEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewApagarEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewApagarEdit.XDataClientApagarGetLoad(Response: TXDataClientResponse);
begin
  ApagarDataset.Close;
  ApagarDataset.SetJsonData(Response.Result);
  ApagarDataset.Open;
  
  ApagarDataset.Edit;  
end;

procedure TFViewApagarEdit.XDataClientApagarDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewApagarEdit.XDataClientApagarDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewApagarEdit.ApagarDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewApagarEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewApagarEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.apagar.form.message');
  lbMessage := TLabel.Create('view.apagar.form.message.label');
  btCloseMessage := TButton.Create('view.apagar.form.message.button');
  btCancel := TButton.Create('view.apagar.form.btBack');
  btSave := TButton.Create('view.apagar.form.btSave');
  btDelete := TButton.Create('view.apagar.form.btDelete');
  lbid := TLabel.Create('view.apagar.form.lbid');
  edid := TDBEdit.Create('view.apagar.form.edid');
  lbaliado_id := TLabel.Create('view.apagar.form.lbaliado_id');
  edaliado_id := TDBEdit.Create('view.apagar.form.edaliado_id');
  lbdata_base_id := TLabel.Create('view.apagar.form.lbdata_base_id');
  eddata_base_id := TDBEdit.Create('view.apagar.form.eddata_base_id');
  lbmodalidade_id := TLabel.Create('view.apagar.form.lbmodalidade_id');
  edmodalidade_id := TDBEdit.Create('view.apagar.form.edmodalidade_id');
  lbcompra_id := TLabel.Create('view.apagar.form.lbcompra_id');
  edcompra_id := TDBEdit.Create('view.apagar.form.edcompra_id');
  lbfornecedor_id := TLabel.Create('view.apagar.form.lbfornecedor_id');
  edfornecedor_id := TDBEdit.Create('view.apagar.form.edfornecedor_id');
  lbplano_contas_id := TLabel.Create('view.apagar.form.lbplano_contas_id');
  edplano_contas_id := TDBEdit.Create('view.apagar.form.edplano_contas_id');
  lbdocumento := TLabel.Create('view.apagar.form.lbdocumento');
  eddocumento := TDBEdit.Create('view.apagar.form.eddocumento');
  lbparcela := TLabel.Create('view.apagar.form.lbparcela');
  edparcela := TDBEdit.Create('view.apagar.form.edparcela');
  lbvalor := TLabel.Create('view.apagar.form.lbvalor');
  edvalor := TDBEdit.Create('view.apagar.form.edvalor');
  lbsaldo := TLabel.Create('view.apagar.form.lbsaldo');
  edsaldo := TDBEdit.Create('view.apagar.form.edsaldo');
  lbpago := TLabel.Create('view.apagar.form.lbpago');
  edpago := TDBEdit.Create('view.apagar.form.edpago');
  lbemissao := TLabel.Create('view.apagar.form.lbemissao');
  edemissao := TDBEdit.Create('view.apagar.form.edemissao');
  lbvencimento := TLabel.Create('view.apagar.form.lbvencimento');
  edvencimento := TDBEdit.Create('view.apagar.form.edvencimento');
  lbpagamento := TLabel.Create('view.apagar.form.lbpagamento');
  edpagamento := TDBEdit.Create('view.apagar.form.edpagamento');
  lbcodigo_interno := TLabel.Create('view.apagar.form.lbcodigo_interno');
  edcodigo_interno := TDBEdit.Create('view.apagar.form.edcodigo_interno');
  lbexcluido := TLabel.Create('view.apagar.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.apagar.form.edexcluido');
  lbinclusao := TLabel.Create('view.apagar.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.apagar.form.edinclusao');
  lbalteracao := TLabel.Create('view.apagar.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.apagar.form.edalteracao');
  lbexclusao := TLabel.Create('view.apagar.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.apagar.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  ApagarDataset := TXDataWebDataSet.Create(Self);
  ApagarDatasetid := TIntegerField.Create(Self);
  ApagarDatasetaliado_id := TIntegerField.Create(Self);
  ApagarDatasetdata_base_id := TIntegerField.Create(Self);
  ApagarDatasetmodalidade_id := TIntegerField.Create(Self);
  ApagarDatasetcompra_id := TIntegerField.Create(Self);
  ApagarDatasetfornecedor_id := TIntegerField.Create(Self);
  ApagarDatasetplano_contas_id := TIntegerField.Create(Self);
  ApagarDatasetdocumento := TStringField.Create(Self);
  ApagarDatasetparcela := TStringField.Create(Self);
  ApagarDatasetvalor := TFloatField.Create(Self);
  ApagarDatasetsaldo := TFloatField.Create(Self);
  ApagarDatasetpago := TFloatField.Create(Self);
  ApagarDatasetemissao := TDateTimeField.Create(Self);
  ApagarDatasetvencimento := TDateTimeField.Create(Self);
  ApagarDatasetpagamento := TDateTimeField.Create(Self);
  ApagarDatasetcodigo_interno := TIntegerField.Create(Self);
  ApagarDatasetexcluido := TBooleanField.Create(Self);
  ApagarDatasetinclusao := TDateTimeField.Create(Self);
  ApagarDatasetalteracao := TDateTimeField.Create(Self);
  ApagarDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientApagarGet := TXDataWebClient.Create(Self);
  XDataClientApagarDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbid.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  lbaliado_id.BeforeLoadDFMValues;
  edaliado_id.BeforeLoadDFMValues;
  lbdata_base_id.BeforeLoadDFMValues;
  eddata_base_id.BeforeLoadDFMValues;
  lbmodalidade_id.BeforeLoadDFMValues;
  edmodalidade_id.BeforeLoadDFMValues;
  lbcompra_id.BeforeLoadDFMValues;
  edcompra_id.BeforeLoadDFMValues;
  lbfornecedor_id.BeforeLoadDFMValues;
  edfornecedor_id.BeforeLoadDFMValues;
  lbplano_contas_id.BeforeLoadDFMValues;
  edplano_contas_id.BeforeLoadDFMValues;
  lbdocumento.BeforeLoadDFMValues;
  eddocumento.BeforeLoadDFMValues;
  lbparcela.BeforeLoadDFMValues;
  edparcela.BeforeLoadDFMValues;
  lbvalor.BeforeLoadDFMValues;
  edvalor.BeforeLoadDFMValues;
  lbsaldo.BeforeLoadDFMValues;
  edsaldo.BeforeLoadDFMValues;
  lbpago.BeforeLoadDFMValues;
  edpago.BeforeLoadDFMValues;
  lbemissao.BeforeLoadDFMValues;
  edemissao.BeforeLoadDFMValues;
  lbvencimento.BeforeLoadDFMValues;
  edvencimento.BeforeLoadDFMValues;
  lbpagamento.BeforeLoadDFMValues;
  edpagamento.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  ApagarDataset.BeforeLoadDFMValues;
  ApagarDatasetid.BeforeLoadDFMValues;
  ApagarDatasetaliado_id.BeforeLoadDFMValues;
  ApagarDatasetdata_base_id.BeforeLoadDFMValues;
  ApagarDatasetmodalidade_id.BeforeLoadDFMValues;
  ApagarDatasetcompra_id.BeforeLoadDFMValues;
  ApagarDatasetfornecedor_id.BeforeLoadDFMValues;
  ApagarDatasetplano_contas_id.BeforeLoadDFMValues;
  ApagarDatasetdocumento.BeforeLoadDFMValues;
  ApagarDatasetparcela.BeforeLoadDFMValues;
  ApagarDatasetvalor.BeforeLoadDFMValues;
  ApagarDatasetsaldo.BeforeLoadDFMValues;
  ApagarDatasetpago.BeforeLoadDFMValues;
  ApagarDatasetemissao.BeforeLoadDFMValues;
  ApagarDatasetvencimento.BeforeLoadDFMValues;
  ApagarDatasetpagamento.BeforeLoadDFMValues;
  ApagarDatasetcodigo_interno.BeforeLoadDFMValues;
  ApagarDatasetexcluido.BeforeLoadDFMValues;
  ApagarDatasetinclusao.BeforeLoadDFMValues;
  ApagarDatasetalteracao.BeforeLoadDFMValues;
  ApagarDatasetexclusao.BeforeLoadDFMValues;
  XDataClientApagarGet.BeforeLoadDFMValues;
  XDataClientApagarDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewApagarEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 805;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 745;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 745;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 745;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 14;
    lbid.Height := 13;
    lbid.Caption := 'id:';
    lbid.Transparent := True;
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := True;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    lbaliado_id.SetParentComponent(Self);
    lbaliado_id.Name := 'lbaliado_id';
    lbaliado_id.Left := 24;
    lbaliado_id.Top := 219;
    lbaliado_id.Width := 14;
    lbaliado_id.Height := 13;
    lbaliado_id.Caption := 'aliado_id:';
    lbaliado_id.Transparent := True;
    edaliado_id.SetParentComponent(Self);
    edaliado_id.Name := 'edaliado_id';
    edaliado_id.Left := 221;
    edaliado_id.Top := 216;
    edaliado_id.Width := 200;
    edaliado_id.Height := 21;
    edaliado_id.Enabled := True;
    edaliado_id.TabOrder := 7;
    edaliado_id.Text := 'edaliado_id';
    edaliado_id.DataField := 'aliado_id';
    edaliado_id.DataSource := DataSource;
    lbdata_base_id.SetParentComponent(Self);
    lbdata_base_id.Name := 'lbdata_base_id';
    lbdata_base_id.Left := 24;
    lbdata_base_id.Top := 246;
    lbdata_base_id.Width := 14;
    lbdata_base_id.Height := 13;
    lbdata_base_id.Caption := 'data_base_id:';
    lbdata_base_id.Transparent := True;
    eddata_base_id.SetParentComponent(Self);
    eddata_base_id.Name := 'eddata_base_id';
    eddata_base_id.Left := 221;
    eddata_base_id.Top := 243;
    eddata_base_id.Width := 200;
    eddata_base_id.Height := 21;
    eddata_base_id.Enabled := True;
    eddata_base_id.TabOrder := 8;
    eddata_base_id.Text := 'eddata_base_id';
    eddata_base_id.DataField := 'data_base_id';
    eddata_base_id.DataSource := DataSource;
    lbmodalidade_id.SetParentComponent(Self);
    lbmodalidade_id.Name := 'lbmodalidade_id';
    lbmodalidade_id.Left := 24;
    lbmodalidade_id.Top := 273;
    lbmodalidade_id.Width := 14;
    lbmodalidade_id.Height := 13;
    lbmodalidade_id.Caption := 'modalidade_id:';
    lbmodalidade_id.Transparent := True;
    edmodalidade_id.SetParentComponent(Self);
    edmodalidade_id.Name := 'edmodalidade_id';
    edmodalidade_id.Left := 221;
    edmodalidade_id.Top := 270;
    edmodalidade_id.Width := 200;
    edmodalidade_id.Height := 21;
    edmodalidade_id.Enabled := True;
    edmodalidade_id.TabOrder := 9;
    edmodalidade_id.Text := 'edmodalidade_id';
    edmodalidade_id.DataField := 'modalidade_id';
    edmodalidade_id.DataSource := DataSource;
    lbcompra_id.SetParentComponent(Self);
    lbcompra_id.Name := 'lbcompra_id';
    lbcompra_id.Left := 24;
    lbcompra_id.Top := 300;
    lbcompra_id.Width := 14;
    lbcompra_id.Height := 13;
    lbcompra_id.Caption := 'compra_id:';
    lbcompra_id.Transparent := True;
    edcompra_id.SetParentComponent(Self);
    edcompra_id.Name := 'edcompra_id';
    edcompra_id.Left := 221;
    edcompra_id.Top := 297;
    edcompra_id.Width := 200;
    edcompra_id.Height := 21;
    edcompra_id.Enabled := True;
    edcompra_id.TabOrder := 10;
    edcompra_id.Text := 'edcompra_id';
    edcompra_id.DataField := 'compra_id';
    edcompra_id.DataSource := DataSource;
    lbfornecedor_id.SetParentComponent(Self);
    lbfornecedor_id.Name := 'lbfornecedor_id';
    lbfornecedor_id.Left := 24;
    lbfornecedor_id.Top := 327;
    lbfornecedor_id.Width := 14;
    lbfornecedor_id.Height := 13;
    lbfornecedor_id.Caption := 'fornecedor_id:';
    lbfornecedor_id.Transparent := True;
    edfornecedor_id.SetParentComponent(Self);
    edfornecedor_id.Name := 'edfornecedor_id';
    edfornecedor_id.Left := 221;
    edfornecedor_id.Top := 324;
    edfornecedor_id.Width := 200;
    edfornecedor_id.Height := 21;
    edfornecedor_id.Enabled := True;
    edfornecedor_id.TabOrder := 11;
    edfornecedor_id.Text := 'edfornecedor_id';
    edfornecedor_id.DataField := 'fornecedor_id';
    edfornecedor_id.DataSource := DataSource;
    lbplano_contas_id.SetParentComponent(Self);
    lbplano_contas_id.Name := 'lbplano_contas_id';
    lbplano_contas_id.Left := 24;
    lbplano_contas_id.Top := 354;
    lbplano_contas_id.Width := 14;
    lbplano_contas_id.Height := 13;
    lbplano_contas_id.Caption := 'plano_contas_id:';
    lbplano_contas_id.Transparent := True;
    edplano_contas_id.SetParentComponent(Self);
    edplano_contas_id.Name := 'edplano_contas_id';
    edplano_contas_id.Left := 221;
    edplano_contas_id.Top := 351;
    edplano_contas_id.Width := 200;
    edplano_contas_id.Height := 21;
    edplano_contas_id.Enabled := True;
    edplano_contas_id.TabOrder := 12;
    edplano_contas_id.Text := 'edplano_contas_id';
    edplano_contas_id.DataField := 'plano_contas_id';
    edplano_contas_id.DataSource := DataSource;
    lbdocumento.SetParentComponent(Self);
    lbdocumento.Name := 'lbdocumento';
    lbdocumento.Left := 24;
    lbdocumento.Top := 381;
    lbdocumento.Width := 14;
    lbdocumento.Height := 13;
    lbdocumento.Caption := 'documento:';
    lbdocumento.Transparent := True;
    eddocumento.SetParentComponent(Self);
    eddocumento.Name := 'eddocumento';
    eddocumento.Left := 221;
    eddocumento.Top := 378;
    eddocumento.Width := 200;
    eddocumento.Height := 21;
    eddocumento.Enabled := True;
    eddocumento.TabOrder := 13;
    eddocumento.Text := 'eddocumento';
    eddocumento.DataField := 'documento';
    eddocumento.DataSource := DataSource;
    lbparcela.SetParentComponent(Self);
    lbparcela.Name := 'lbparcela';
    lbparcela.Left := 24;
    lbparcela.Top := 408;
    lbparcela.Width := 14;
    lbparcela.Height := 13;
    lbparcela.Caption := 'parcela:';
    lbparcela.Transparent := True;
    edparcela.SetParentComponent(Self);
    edparcela.Name := 'edparcela';
    edparcela.Left := 221;
    edparcela.Top := 405;
    edparcela.Width := 200;
    edparcela.Height := 21;
    edparcela.Enabled := True;
    edparcela.TabOrder := 14;
    edparcela.Text := 'edparcela';
    edparcela.DataField := 'parcela';
    edparcela.DataSource := DataSource;
    lbvalor.SetParentComponent(Self);
    lbvalor.Name := 'lbvalor';
    lbvalor.Left := 24;
    lbvalor.Top := 435;
    lbvalor.Width := 14;
    lbvalor.Height := 13;
    lbvalor.Caption := 'valor:';
    lbvalor.Transparent := True;
    edvalor.SetParentComponent(Self);
    edvalor.Name := 'edvalor';
    edvalor.Left := 221;
    edvalor.Top := 432;
    edvalor.Width := 200;
    edvalor.Height := 21;
    edvalor.Enabled := True;
    edvalor.TabOrder := 15;
    edvalor.Text := 'edvalor';
    edvalor.DataField := 'valor';
    edvalor.DataSource := DataSource;
    lbsaldo.SetParentComponent(Self);
    lbsaldo.Name := 'lbsaldo';
    lbsaldo.Left := 24;
    lbsaldo.Top := 462;
    lbsaldo.Width := 14;
    lbsaldo.Height := 13;
    lbsaldo.Caption := 'saldo:';
    lbsaldo.Transparent := True;
    edsaldo.SetParentComponent(Self);
    edsaldo.Name := 'edsaldo';
    edsaldo.Left := 221;
    edsaldo.Top := 459;
    edsaldo.Width := 200;
    edsaldo.Height := 21;
    edsaldo.Enabled := True;
    edsaldo.TabOrder := 16;
    edsaldo.Text := 'edsaldo';
    edsaldo.DataField := 'saldo';
    edsaldo.DataSource := DataSource;
    lbpago.SetParentComponent(Self);
    lbpago.Name := 'lbpago';
    lbpago.Left := 24;
    lbpago.Top := 489;
    lbpago.Width := 14;
    lbpago.Height := 13;
    lbpago.Caption := 'pago:';
    lbpago.Transparent := True;
    edpago.SetParentComponent(Self);
    edpago.Name := 'edpago';
    edpago.Left := 221;
    edpago.Top := 486;
    edpago.Width := 200;
    edpago.Height := 21;
    edpago.Enabled := True;
    edpago.TabOrder := 17;
    edpago.Text := 'edpago';
    edpago.DataField := 'pago';
    edpago.DataSource := DataSource;
    lbemissao.SetParentComponent(Self);
    lbemissao.Name := 'lbemissao';
    lbemissao.Left := 24;
    lbemissao.Top := 516;
    lbemissao.Width := 14;
    lbemissao.Height := 13;
    lbemissao.Caption := 'emissao:';
    lbemissao.Transparent := True;
    edemissao.SetParentComponent(Self);
    edemissao.Name := 'edemissao';
    edemissao.Left := 221;
    edemissao.Top := 513;
    edemissao.Width := 200;
    edemissao.Height := 21;
    edemissao.Enabled := True;
    edemissao.TabOrder := 18;
    edemissao.Text := 'edemissao';
    edemissao.DataField := 'emissao';
    edemissao.DataSource := DataSource;
    lbvencimento.SetParentComponent(Self);
    lbvencimento.Name := 'lbvencimento';
    lbvencimento.Left := 24;
    lbvencimento.Top := 543;
    lbvencimento.Width := 14;
    lbvencimento.Height := 13;
    lbvencimento.Caption := 'vencimento:';
    lbvencimento.Transparent := True;
    edvencimento.SetParentComponent(Self);
    edvencimento.Name := 'edvencimento';
    edvencimento.Left := 221;
    edvencimento.Top := 540;
    edvencimento.Width := 200;
    edvencimento.Height := 21;
    edvencimento.Enabled := True;
    edvencimento.TabOrder := 19;
    edvencimento.Text := 'edvencimento';
    edvencimento.DataField := 'vencimento';
    edvencimento.DataSource := DataSource;
    lbpagamento.SetParentComponent(Self);
    lbpagamento.Name := 'lbpagamento';
    lbpagamento.Left := 24;
    lbpagamento.Top := 570;
    lbpagamento.Width := 14;
    lbpagamento.Height := 13;
    lbpagamento.Caption := 'pagamento:';
    lbpagamento.Transparent := True;
    edpagamento.SetParentComponent(Self);
    edpagamento.Name := 'edpagamento';
    edpagamento.Left := 221;
    edpagamento.Top := 567;
    edpagamento.Width := 200;
    edpagamento.Height := 21;
    edpagamento.Enabled := True;
    edpagamento.TabOrder := 20;
    edpagamento.Text := 'edpagamento';
    edpagamento.DataField := 'pagamento';
    edpagamento.DataSource := DataSource;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 24;
    lbcodigo_interno.Top := 597;
    lbcodigo_interno.Width := 14;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'codigo_interno:';
    lbcodigo_interno.Transparent := True;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 221;
    edcodigo_interno.Top := 594;
    edcodigo_interno.Width := 200;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := True;
    edcodigo_interno.TabOrder := 21;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 624;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 621;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 22;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 651;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 648;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 23;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 678;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 675;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 24;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 705;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 702;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 25;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := ApagarDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    ApagarDataset.SetParentComponent(Self);
    ApagarDataset.Name := 'ApagarDataset';
    ApagarDataset.AfterApplyUpdates := ApagarDatasetAfterApplyUpdates;
    ApagarDataset.EntitySetName := 'Apagar';
    ApagarDataset.Connection := DMConnection.ApiConnection;
    ApagarDataset.Left := 176;
    ApagarDataset.Top := 8;
    ApagarDatasetid.SetParentComponent(ApagarDataset);
    ApagarDatasetid.Name := 'ApagarDatasetid';
    ApagarDatasetid.FieldName := 'id';
    ApagarDatasetid.Required := True;
    ApagarDatasetaliado_id.SetParentComponent(ApagarDataset);
    ApagarDatasetaliado_id.Name := 'ApagarDatasetaliado_id';
    ApagarDatasetaliado_id.FieldName := 'aliado_id';
    ApagarDatasetaliado_id.Required := True;
    ApagarDatasetdata_base_id.SetParentComponent(ApagarDataset);
    ApagarDatasetdata_base_id.Name := 'ApagarDatasetdata_base_id';
    ApagarDatasetdata_base_id.FieldName := 'data_base_id';
    ApagarDatasetdata_base_id.Required := True;
    ApagarDatasetmodalidade_id.SetParentComponent(ApagarDataset);
    ApagarDatasetmodalidade_id.Name := 'ApagarDatasetmodalidade_id';
    ApagarDatasetmodalidade_id.FieldName := 'modalidade_id';
    ApagarDatasetmodalidade_id.Required := True;
    ApagarDatasetcompra_id.SetParentComponent(ApagarDataset);
    ApagarDatasetcompra_id.Name := 'ApagarDatasetcompra_id';
    ApagarDatasetcompra_id.FieldName := 'compra_id';
    ApagarDatasetcompra_id.Required := False;
    ApagarDatasetfornecedor_id.SetParentComponent(ApagarDataset);
    ApagarDatasetfornecedor_id.Name := 'ApagarDatasetfornecedor_id';
    ApagarDatasetfornecedor_id.FieldName := 'fornecedor_id';
    ApagarDatasetfornecedor_id.Required := False;
    ApagarDatasetplano_contas_id.SetParentComponent(ApagarDataset);
    ApagarDatasetplano_contas_id.Name := 'ApagarDatasetplano_contas_id';
    ApagarDatasetplano_contas_id.FieldName := 'plano_contas_id';
    ApagarDatasetplano_contas_id.Required := False;
    ApagarDatasetdocumento.SetParentComponent(ApagarDataset);
    ApagarDatasetdocumento.Name := 'ApagarDatasetdocumento';
    ApagarDatasetdocumento.FieldName := 'documento';
    ApagarDatasetdocumento.Required := False;
    ApagarDatasetdocumento.Size := 255;
    ApagarDatasetparcela.SetParentComponent(ApagarDataset);
    ApagarDatasetparcela.Name := 'ApagarDatasetparcela';
    ApagarDatasetparcela.FieldName := 'parcela';
    ApagarDatasetparcela.Required := False;
    ApagarDatasetparcela.Size := 255;
    ApagarDatasetvalor.SetParentComponent(ApagarDataset);
    ApagarDatasetvalor.Name := 'ApagarDatasetvalor';
    ApagarDatasetvalor.FieldName := 'valor';
    ApagarDatasetvalor.Required := True;
    ApagarDatasetsaldo.SetParentComponent(ApagarDataset);
    ApagarDatasetsaldo.Name := 'ApagarDatasetsaldo';
    ApagarDatasetsaldo.FieldName := 'saldo';
    ApagarDatasetsaldo.Required := False;
    ApagarDatasetpago.SetParentComponent(ApagarDataset);
    ApagarDatasetpago.Name := 'ApagarDatasetpago';
    ApagarDatasetpago.FieldName := 'pago';
    ApagarDatasetpago.Required := False;
    ApagarDatasetemissao.SetParentComponent(ApagarDataset);
    ApagarDatasetemissao.Name := 'ApagarDatasetemissao';
    ApagarDatasetemissao.FieldName := 'emissao';
    ApagarDatasetemissao.Required := False;
    ApagarDatasetvencimento.SetParentComponent(ApagarDataset);
    ApagarDatasetvencimento.Name := 'ApagarDatasetvencimento';
    ApagarDatasetvencimento.FieldName := 'vencimento';
    ApagarDatasetvencimento.Required := True;
    ApagarDatasetpagamento.SetParentComponent(ApagarDataset);
    ApagarDatasetpagamento.Name := 'ApagarDatasetpagamento';
    ApagarDatasetpagamento.FieldName := 'pagamento';
    ApagarDatasetpagamento.Required := False;
    ApagarDatasetcodigo_interno.SetParentComponent(ApagarDataset);
    ApagarDatasetcodigo_interno.Name := 'ApagarDatasetcodigo_interno';
    ApagarDatasetcodigo_interno.FieldName := 'codigo_interno';
    ApagarDatasetcodigo_interno.Required := True;
    ApagarDatasetexcluido.SetParentComponent(ApagarDataset);
    ApagarDatasetexcluido.Name := 'ApagarDatasetexcluido';
    ApagarDatasetexcluido.FieldName := 'excluido';
    ApagarDatasetexcluido.Required := False;
    ApagarDatasetinclusao.SetParentComponent(ApagarDataset);
    ApagarDatasetinclusao.Name := 'ApagarDatasetinclusao';
    ApagarDatasetinclusao.FieldName := 'inclusao';
    ApagarDatasetinclusao.Required := False;
    ApagarDatasetalteracao.SetParentComponent(ApagarDataset);
    ApagarDatasetalteracao.Name := 'ApagarDatasetalteracao';
    ApagarDatasetalteracao.FieldName := 'alteracao';
    ApagarDatasetalteracao.Required := False;
    ApagarDatasetexclusao.SetParentComponent(ApagarDataset);
    ApagarDatasetexclusao.Name := 'ApagarDatasetexclusao';
    ApagarDatasetexclusao.FieldName := 'exclusao';
    ApagarDatasetexclusao.Required := False;
    XDataClientApagarGet.SetParentComponent(Self);
    XDataClientApagarGet.Name := 'XDataClientApagarGet';
    XDataClientApagarGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientApagarGet, Self, 'OnLoad', 'XDataClientApagarGetLoad');
    XDataClientApagarGet.Left := 64;
    XDataClientApagarGet.Top := 8;
    XDataClientApagarDelete.SetParentComponent(Self);
    XDataClientApagarDelete.Name := 'XDataClientApagarDelete';
    XDataClientApagarDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientApagarDelete, Self, 'OnLoad', 'XDataClientApagarDeleteLoad');
    SetEvent(XDataClientApagarDelete, Self, 'OnError', 'XDataClientApagarDeleteError');
    XDataClientApagarDelete.Left := 64;
    XDataClientApagarDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbid.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    lbaliado_id.AfterLoadDFMValues;
    edaliado_id.AfterLoadDFMValues;
    lbdata_base_id.AfterLoadDFMValues;
    eddata_base_id.AfterLoadDFMValues;
    lbmodalidade_id.AfterLoadDFMValues;
    edmodalidade_id.AfterLoadDFMValues;
    lbcompra_id.AfterLoadDFMValues;
    edcompra_id.AfterLoadDFMValues;
    lbfornecedor_id.AfterLoadDFMValues;
    edfornecedor_id.AfterLoadDFMValues;
    lbplano_contas_id.AfterLoadDFMValues;
    edplano_contas_id.AfterLoadDFMValues;
    lbdocumento.AfterLoadDFMValues;
    eddocumento.AfterLoadDFMValues;
    lbparcela.AfterLoadDFMValues;
    edparcela.AfterLoadDFMValues;
    lbvalor.AfterLoadDFMValues;
    edvalor.AfterLoadDFMValues;
    lbsaldo.AfterLoadDFMValues;
    edsaldo.AfterLoadDFMValues;
    lbpago.AfterLoadDFMValues;
    edpago.AfterLoadDFMValues;
    lbemissao.AfterLoadDFMValues;
    edemissao.AfterLoadDFMValues;
    lbvencimento.AfterLoadDFMValues;
    edvencimento.AfterLoadDFMValues;
    lbpagamento.AfterLoadDFMValues;
    edpagamento.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    ApagarDataset.AfterLoadDFMValues;
    ApagarDatasetid.AfterLoadDFMValues;
    ApagarDatasetaliado_id.AfterLoadDFMValues;
    ApagarDatasetdata_base_id.AfterLoadDFMValues;
    ApagarDatasetmodalidade_id.AfterLoadDFMValues;
    ApagarDatasetcompra_id.AfterLoadDFMValues;
    ApagarDatasetfornecedor_id.AfterLoadDFMValues;
    ApagarDatasetplano_contas_id.AfterLoadDFMValues;
    ApagarDatasetdocumento.AfterLoadDFMValues;
    ApagarDatasetparcela.AfterLoadDFMValues;
    ApagarDatasetvalor.AfterLoadDFMValues;
    ApagarDatasetsaldo.AfterLoadDFMValues;
    ApagarDatasetpago.AfterLoadDFMValues;
    ApagarDatasetemissao.AfterLoadDFMValues;
    ApagarDatasetvencimento.AfterLoadDFMValues;
    ApagarDatasetpagamento.AfterLoadDFMValues;
    ApagarDatasetcodigo_interno.AfterLoadDFMValues;
    ApagarDatasetexcluido.AfterLoadDFMValues;
    ApagarDatasetinclusao.AfterLoadDFMValues;
    ApagarDatasetalteracao.AfterLoadDFMValues;
    ApagarDatasetexclusao.AfterLoadDFMValues;
    XDataClientApagarGet.AfterLoadDFMValues;
    XDataClientApagarDelete.AfterLoadDFMValues;
  end;
end;

end.
